'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' });

var ArrowBack = function ArrowBack(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ArrowBack = (0, _pure2.default)(ArrowBack);
ArrowBack.muiName = 'SvgIcon';

exports.default = ArrowBack;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ArrowBack.js
// module id = 2123
// module chunks = 0